import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section6({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-128">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-129">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-130">
          <span className="text-dorado mr-2" data-id="element-131">Sección 06 ·</span>
          Mente y Emociones
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-132">
          La mentalidad es clave para sostener cualquier cambio físico.
        </p>
      </div>

      <FormField label={`Nivel de estrés actual: ${data.estres || 5}/10`} name="estres" error={errors.estres} required description="1 = Muy relajado/a, 10 = Extremadamente estresado/a" data-id="element-133">
        <input type="range" min="1" max="10" value={data.estres || 5} onChange={e => onChange('estres', parseInt(e.target.value))} className="w-full h-2 bg-plateado rounded-lg appearance-none cursor-pointer accent-dorado" data-id="element-134" />
        <div className="flex justify-between text-xs text-gray-500 mt-2" data-id="element-135">
          <span data-id="element-136">Relajado/a (1)</span>
          <span data-id="element-137">Muy estresado/a (10)</span>
        </div>
      </FormField>

      <FormField label="¿Cómo manejas el estrés o la ansiedad actualmente?" name="manejoEstres" error={errors.manejoEstres} required description="Ej. Como en exceso, hago ejercicio, me aíslo, medito, etc." data-id="element-138">
        <TextArea id="manejoEstres" value={data.manejoEstres} onChange={e => onChange('manejoEstres', e.target.value)} error={!!errors.manejoEstres} placeholder="Describe tus mecanismos actuales..." className="min-h-[100px]" data-id="element-139" />
      </FormField>

      <FormField label="¿Practicas meditación, mindfulness o respiración consciente?" name="meditacion" error={errors.meditacion} required data-id="element-140">
        <div className="space-y-3 mt-2" data-id="element-141">
          {['Nunca lo he intentado', 'Ocasionalmente (cuando me acuerdo)', 'Regularmente (1-3 veces por semana)', 'Práctica diaria'].map(option => <label key={option} className="flex items-center space-x-3 p-3 border-2 border-plateado rounded-xl cursor-pointer hover:border-dorado transition-colors bg-white" data-id="element-142">
              <input type="radio" name="meditacion" value={option} checked={data.meditacion === option} onChange={e => onChange('meditacion', e.target.value)} className="w-5 h-5 text-dorado focus:ring-dorado" data-id="element-143" />
              <span className="text-texto-oscuro" data-id="element-144">{option}</span>
            </label>)}
        </div>
      </FormField>

      <FormField label="¿Cuáles son tus principales pensamientos limitantes respecto a tu cuerpo o salud?" name="pensamientos" error={errors.pensamientos} required description="Ej. 'No tengo fuerza de voluntad', 'Es muy difícil a mi edad', 'No tengo tiempo'." data-id="element-145">
        <TextArea id="pensamientos" value={data.pensamientos} onChange={e => onChange('pensamientos', e.target.value)} error={!!errors.pensamientos} placeholder="Sé honesto/a contigo mismo/a..." className="min-h-[100px]" data-id="element-146" />
      </FormField>
    </div>;
}